{
  "title": "Lead",
  "permissionDenied": "Bạn không có quyền xem danh sách lead",
  "pages": {
    "addTitle": "Thêm lead",
    "editTitle": "Sửa lead",
    "detailsTitle": "Chi tiết lead",
    "createPermissionDenied": "Bạn không có quyền tạo lead",
    "editPermissionDenied": "Bạn không có quyền sửa lead"
  },
  "fields": {
    "firstName": "Tên",
    "lastName": "Họ",
    "phone": "Số điện thoại",
    "email": "Email",
    "gender": "Giới tính",
    "dateOfBirth": "Ngày sinh",
    "clinic": "Chi nhánh",
    "customerSource": "Nguồn khách hàng",
    "referredBy": "Người giới thiệu",
    "treatmentInterest": "Nhu cầu điều trị",
    "nearestAppointment": "Lịch hẹn gần nhất",
    "assignee": "Người phụ trách",
    "status": "Trạng thái",
    "lostReason": "Lý do mất lead",
    "note": "Ghi chú",
    "notes": "Ghi chú",
    "contactLog": "Nhật ký liên hệ",
    "channel": "Kênh",
    "outcome": "Kết quả",
    "contactNote": "Ghi chú cuộc liên hệ",
    "contactStaff": "Người liên hệ",
    "contactedAt": "Ngày liên hệ",
    "callbackDueAt": "Hạn gọi lại",
    "information": "Thông tin lead",
    "convertedPatient": "Bệnh nhân",
    "unassigned": "Chưa gán",
    "relatedTasks": "Công việc liên quan",
    "adAttributions": "Nguồn quảng cáo"
  },
  "placeholders": {
    "lastName": "Nhập họ và chữ lót",
    "firstName": "Nhập tên",
    "phone": "Ví dụ: 0901234567",
    "email": "email@example.com",
    "gender": "Chọn giới tính",
    "clinic": "Chọn chi nhánh",
    "customerSource": "Chọn nguồn khách hàng",
    "treatmentInterest": "Chọn nhu cầu điều trị",
    "assignee": "Chọn người phụ trách",
    "contactStaff": "Chọn người liên hệ",
    "contactNote": "Ghi nội dung cuộc gọi hoặc tin nhắn",
    "referredBy": "Nhập tên hoặc số điện thoại",
    "note": "Ghi chú khi tiếp nhận lead"
  },
  "referredByKind": {
    "patient": "Bệnh nhân",
    "staff": "Nhân viên",
    "external": "Đối tác"
  },
  "referredBySearch": {
    "hint": "Nhập ít nhất 2 ký tự",
    "empty": "Không tìm thấy"
  },
  "channel": {
    "phone": "Điện thoại",
    "zalo": "Zalo",
    "sms": "SMS",
    "email": "Email",
    "in_person": "Gặp trực tiếp",
    "other": "Khác"
  },
  "outcome": {
    "reached": "Đã liên hệ được",
    "no_answer": "Không nghe máy",
    "callback": "Hẹn gọi lại",
    "wrong_number": "Sai số",
    "interested": "Quan tâm",
    "not_interested": "Không quan tâm",
    "other": "Khác"
  },
  "status": {
    "new": "Mới tiếp nhận",
    "in_progress": "Đang tư vấn",
    "appointment_booked": "Đã đặt lịch",
    "unqualified": "Không tiềm năng",
    "won": "Thành công",
    "lost": "Thất bại"
  },
  "lostReason": {
    "price": "Giá",
    "distance": "Xa",
    "chose_other": "Chọn phòng khám khác",
    "no_response": "Không phản hồi",
    "spam": "Spam / không hợp lệ",
    "other": "Khác"
  },
  "treatmentInterest": {
    "scaling": "Cạo vôi răng",
    "implant": "Implant",
    "general_exam": "Kiểm tra răng",
    "pediatric": "Nha khoa trẻ em",
    "other": "Nhu cầu khác",
    "ortho": "Niềng răng",
    "ceramic": "Răng sứ",
    "whitening": "Tẩy trắng"
  },
  "gender": {
    "male": "Nam",
    "female": "Nữ",
    "other": "Khác"
  },
  "filters": {
    "filters": "Bộ lọc",
    "filterTitle": "Lọc lead",
    "clearAll": "Xóa tất cả",
    "applyFilters": "Áp dụng",
    "status": "Trạng thái",
    "assignee": "Người phụ trách",
    "source": "Nguồn",
    "clinic": "Chi nhánh",
    "treatmentInterest": "Nhu cầu",
    "selectStatus": "Chọn trạng thái",
    "selectSource": "Chọn nguồn",
    "selectAssignee": "Chọn người phụ trách",
    "selectClinic": "Chọn chi nhánh",
    "allStatuses": "Tất cả trạng thái",
    "allSources": "Tất cả nguồn",
    "allInterests": "Tất cả nhu cầu",
    "allAssignees": "Tất cả",
    "allClinics": "Tất cả chi nhánh"
  },
  "details": {
    "timeline": "Dòng thời gian",
    "tasks": "Công việc"
  },
  "timeline": {
    "empty": "Chưa có sự kiện",
    "loadingMore": "Đang tải thêm…",
    "viewLabel": "Cách xem dòng thời gian",
    "viewTimeline": "Dòng thời gian",
    "viewTable": "Bảng",
    "columns": {
      "time": "Thời gian",
      "kind": "Loại",
      "content": "Nội dung",
      "actor": "Người thực hiện"
    },
    "kinds": {
      "created": "Tạo lead",
      "status": "Trạng thái",
      "contact": "Liên hệ",
      "note": "Ghi chú",
      "task": "Công việc",
      "appointment": "Lịch hẹn",
      "converted": "Chuyển bệnh nhân"
    },
    "filters": {
      "all": "Tất cả",
      "contact": "Liên hệ",
      "status": "Trạng thái",
      "note": "Ghi chú",
      "task": "Công việc",
      "appointment": "Lịch hẹn"
    },
    "record": {
      "emptyStatus": "Chưa có lần đổi trạng thái",
      "emptyAppointment": "Chưa có lịch hẹn",
      "contact": {
        "date": "Ngày liên hệ",
        "channel": "Kênh liên hệ",
        "outcome": "Kết quả",
        "text": "Nội dung",
        "person": "Người liên hệ",
        "callback": "Hẹn gọi lại"
      },
      "status": {
        "at": "Thời điểm",
        "from": "Trạng thái cũ",
        "to": "Trạng thái mới",
        "reason": "Lý do",
        "person": "Người thực hiện"
      },
      "note": {
        "date": "Ngày",
        "text": "Nội dung",
        "person": "Người"
      },
      "task": {
        "title": "Tiêu đề",
        "status": "Trạng thái",
        "assignee": "Người được giao",
        "due": "Hạn",
        "completedBy": "Người hoàn thành"
      },
      "appointment": {
        "when": "Ngày giờ",
        "dentist": "Bác sĩ",
        "status": "Trạng thái",
        "reason": "Lý do",
        "chair": "Ghế"
      }
    },
    "roles": {
      "assignee": "Phụ trách: {{name}}",
      "actor": "Thực hiện hành động: {{name}}"
    },
    "events": {
      "created": "Lead được tạo",
      "statusChange": "{{from}} → {{to}}",
      "statusSet": "{{to}}",
      "lostReason": "Lý do: {{reason}}",
      "note": "Ghi chú",
      "contact": "Liên hệ",
      "converted": "Chuyển thành bệnh nhân",
      "taskCreated": "Tạo công việc",
      "taskCompleted": "Hoàn thành công việc",
      "appointment": "Lịch hẹn",
      "appointmentCoded": "Lịch hẹn {{code}}",
      "callbackDue": "Hạn gọi lại {{date}}"
    }
  },
  "views": {
    "label": "Kiểu xem",
    "list": "Danh sách",
    "kanban": "Kanban"
  },
  "kanban": {
    "emptyColumn": "Chưa có lead",
    "lostDropHint": "Kéo lead vào đây",
    "lostReasonTitle": "Lý do thất bại",
    "loading": "Đang tải bảng...",
    "truncated": "Mỗi cột hiển thị tối đa {{limit}} lead. Dùng tìm kiếm hoặc bộ lọc để thu hẹp.",
    "terminalFilter": "Kanban chỉ hiện lead đang xử lý. Lead đã kết thúc nằm ở danh sách."
  },
  "actions": {
    "add": "Thêm lead",
    "convert": "Chuyển thành bệnh nhân",
    "bookAppointment": "Đặt lịch hẹn",
    "changeStatus": "Đổi trạng thái",
    "addNote": "Thêm ghi chú",
    "addContact": "Ghi liên hệ",
    "addingContact": "Đang ghi liên hệ...",
    "createTask": "Tạo công việc",
    "viewReports": "Báo cáo lead",
    "viewPatient": "Xem bệnh nhân",
    "moreActions": "Thêm thao tác"
  },
  "reports": {
    "title": "Báo cáo Lead",
    "generate": "Xem báo cáo",
    "back": "Quay lại danh sách",
    "from": "Từ ngày",
    "to": "Đến ngày",
    "summary": "Tổng quan",
    "total": "Tổng lead",
    "converted": "Thành công",
    "lost": "Thất bại",
    "active": "Đang xử lý",
    "conversionRate": "Tỷ lệ thành công",
    "avgDaysToConvert": "TB ngày đến thành công",
    "byStatus": "Theo trạng thái",
    "bySource": "Theo nguồn",
    "byAssignee": "Theo người phụ trách",
    "byTreatmentInterest": "Theo nhu cầu điều trị",
    "byCampaign": "Theo chiến dịch",
    "byAdset": "Theo nhóm quảng cáo",
    "byAd": "Theo mẫu quảng cáo",
    "adDateHint": "Bảng quảng cáo lọc theo ngày hội thoại từ quảng cáo, không theo ngày tạo lead.",
    "count": "Số lượng",
    "loadFailed": "Không tải được báo cáo",
    "permissionDenied": "Bạn không có quyền xem báo cáo lead"
  },
  "convert": {
    "title": "Chuyển lead thành bệnh nhân",
    "hint": "Bổ sung thông tin bắt buộc để tạo hồ sơ bệnh nhân.",
    "submit": "Chuyển đổi",
    "submitting": "Đang chuyển đổi"
  },
  "validation": {
    "firstNameRequired": "Vui lòng nhập tên",
    "customerSourceRequired": "Vui lòng chọn nguồn khách hàng",
    "lostReasonRequired": "Vui lòng chọn lý do mất lead",
    "genderRequired": "Vui lòng chọn giới tính",
    "dateOfBirthRequired": "Vui lòng chọn ngày sinh",
    "clinicRequired": "Vui lòng chọn chi nhánh",
    "contactRequired": "Cần có số điện thoại hoặc email để chuyển đổi",
    "contactStaffRequired": "Vui lòng chọn người liên hệ",
    "contactedAtRequired": "Vui lòng chọn ngày liên hệ",
    "callbackDueRequired": "Vui lòng chọn hạn gọi lại"
  },
  "toasts": {
    "createSuccess": "Đã tạo lead",
    "updateSuccess": "Đã cập nhật lead",
    "deleteSuccess": "Đã xóa lead",
    "statusUpdated": "Đã đổi trạng thái",
    "assigneeUpdated": "Đã đổi người phụ trách",
    "noteAdded": "Đã thêm ghi chú",
    "contactAdded": "Đã ghi nhật ký liên hệ",
    "contactAddedWithTask": "Đã ghi liên hệ và tạo công việc gọi lại",
    "contactAddedTaskSkipped": "Đã ghi liên hệ. Chưa tạo được công việc gọi lại vì tài khoản không có quyền tạo công việc.",
    "contactAddedTaskFailed": "Đã ghi liên hệ. Không tạo được công việc gọi lại.",
    "convertSuccess": "Đã chuyển lead thành bệnh nhân",
    "loadFailed": "Không tải được danh sách lead",
    "loadOneFailed": "Không tải được lead",
    "saveFailed": "Không lưu được lead",
    "deleteFailed": "Không xóa được lead",
    "deleteWonBlocked": "Không xóa được lead đã chuyển thành bệnh nhân.",
    "deleteBlocked": "Không xóa được lead vì còn {{items}} gắn với lead này.",
    "deleteBlockedRelations": {
      "appointment": "lịch hẹn",
      "task": "công việc",
      "conversation": "hội thoại",
      "external_identity": "danh tính kênh"
    },
    "statusUpdateFailed": "Không đổi được trạng thái",
    "assigneeUpdateFailed": "Không đổi được người phụ trách",
    "noteFailed": "Không thêm được ghi chú",
    "contactFailed": "Không ghi được nhật ký liên hệ",
    "convertFailed": "Không chuyển đổi được lead"
  },
  "dialogs": {
    "deleteNamedConfirm": "Xóa lead \"{{name}}\"?"
  },
  "misc": {
    "notFound": "Không tìm thấy lead",
    "noNotes": "Chưa có ghi chú",
    "noContactLogs": "Chưa có nhật ký liên hệ",
    "noTasks": "Chưa có công việc liên quan",
    "empty": "Chưa có lead nào"
  },
  "table": {
    "name": "Họ tên",
    "leadCode": "ID Lead",
    "phone": "SĐT",
    "status": "Trạng thái",
    "source": "Nguồn lead",
    "interest": "Nhu cầu",
    "assignee": "Phụ trách",
    "clinic": "Chi nhánh",
    "email": "Email",
    "gender": "Giới tính",
    "lostReason": "Lý do mất lead",
    "referredBy": "Người giới thiệu",
    "note": "Ghi chú",
    "convertedPatient": "Bệnh nhân",
    "convertedAt": "Ngày chuyển đổi",
    "createdBy": "Người tạo",
    "createdAt": "Ngày tạo",
    "updatedAt": "Cập nhật"
  }
}
